import { HttpClient, HttpContext, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiConfiguration } from '@/core/api/api-configuration';
import { BaseService } from '@/core/api/base-service';
import { PrestadorAlterarSituacaoRequest, PrestadorAlterarSituacaoResponse, PrestadorInadimplenteResponse, PrestadorProrrogacaoRequest, PrestadorProrrogacaoResponse } from '@/core/api/sicom-api/registro/prestador/prestador-situacao.model';
import { Pessoa } from '@/shared/models/pessoa-info.model';
import { environment } from '@env/environment';
import { SICOM_PATHS } from 'src/sicom-paths';

@Injectable({ providedIn: 'root' })
export class PrestadorSituacaoService extends BaseService {
    readonly PATH = SICOM_PATHS.registro.prestador.situacao;

    constructor(config: ApiConfiguration, http: HttpClient) {
        super(config, http, environment.apis.apiSicom);
    }

    /**
     * PUT /situacao — altera a situação do prestador (cascata / bloqueios / reativação por grupos).
     * Situação 6/7 com inadimplência não confirmada responde 409 (title INADIMPLENCIA_CONFIRMAR);
     * reenvie com confirmaInadimplencia = true para prosseguir.
     */
    alterarSituacao(body: PrestadorAlterarSituacaoRequest, context?: HttpContext): Observable<PrestadorAlterarSituacaoResponse> {
        return this.http.put<PrestadorAlterarSituacaoResponse>(this.PATH, body, { context });
    }

    /** GET /situacao/inadimplente — checagem preventiva de inadimplência (alerta de cancelamento 6/7). */
    verificarInadimplente(params: Pessoa, context?: HttpContext): Observable<PrestadorInadimplenteResponse> {
        const httpParams = new HttpParams().set('id', String(params.id)).set('uf', String(params.uf));
        return this.http.get<PrestadorInadimplenteResponse>(`${this.PATH}/inadimplente`, { params: httpParams, context });
    }

    /**
     * PUT /prorrogacao — prorroga o prazo do prestador com inscrição provisória pendente
     * (habilitado apenas para tipo de inscrição 2 + situação 2).
     */
    prorrogarPrazo(body: PrestadorProrrogacaoRequest, context?: HttpContext): Observable<PrestadorProrrogacaoResponse> {
        return this.http.put<PrestadorProrrogacaoResponse>(SICOM_PATHS.registro.prestador.prorrogacao, body, { context });
    }
}
